module.exports = __webpack_public_path__ + "static/media/ic-recommendation1.1-dei.12c1c644.png";